module.exports = __webpack_public_path__ + "img/img-coupon-bg-500-x-500.0caff5d1.png";